/* Beden & Kalıp rehberi - sekmeler, CM/İNÇ, beden asistanı, modal yönetimi */
(function () {
  'use strict';
  if (window.__naxroSizeGuide) return;
  window.__naxroSizeGuide = true;

  var active = null; // { modal, trigger }

  function qs(el, sel) { return el.querySelector(sel); }
  function qsa(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }

  /* ---------- Modal'ı body'ye taşı (sticky/transform sorunlarını önler) ---------- */
  function getModal(root) {
    if (root.__sgModal && document.body.contains(root.__sgModal)) return root.__sgModal;
    var modal = qs(root, '[data-sg-modal]');
    if (!modal) return null;
    var id = modal.getAttribute('data-sg-modal');
    qsa(document.body, '[data-sg-modal="' + id + '"]').forEach(function (old) {
      if (old !== modal && old.parentNode === document.body) old.parentNode.removeChild(old);
    });
    document.body.appendChild(modal);
    modal.__sgRoot = root;
    root.__sgModal = modal;
    initModal(modal);
    return modal;
  }

  /* ---------- Aç / Kapat ---------- */
  function open(root, trigger) {
    var modal = getModal(root);
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('sg-scroll-lock');
    trigger.setAttribute('aria-expanded', 'true');
    active = { modal: modal, trigger: trigger };
    var tab = qs(modal, '[data-sg-tab][aria-selected="true"]');
    (tab || qs(modal, '.sg-dialog')).focus();
  }

  function close() {
    if (!active) return;
    active.modal.hidden = true;
    document.documentElement.classList.remove('sg-scroll-lock');
    if (active.trigger) {
      active.trigger.setAttribute('aria-expanded', 'false');
      try { active.trigger.focus(); } catch (e) {}
    }
    active = null;
  }

  /* ---------- Sekmeler ---------- */
  function selectTab(modal, name, focus) {
    qsa(modal, '[data-sg-tab]').forEach(function (t) {
      var on = t.getAttribute('data-sg-tab') === name;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    qsa(modal, '[data-sg-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-sg-panel') !== name;
    });
    var body = qs(modal, '.sg-body');
    if (body) body.scrollTop = 0;
  }

  /* ---------- CM / İNÇ ---------- */
  function setUnit(modal, unit) {
    qsa(modal, '[data-sg-unit]').forEach(function (b) {
      var on = b.getAttribute('data-sg-unit') === unit;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    qsa(modal, '[data-sg-unit-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-sg-unit-panel') !== unit;
    });
  }

  /* ---------- Beden asistanı (boy / kilo -> beden) ---------- */
  function parseRange(str) {
    var s = String(str || '').replace(/,/g, '.');
    var m = s.match(/(\d+(?:\.\d+)?)\s*[-\u2013\u2014]\s*(\d+(?:\.\d+)?)/);
    if (m) {
      var a = parseFloat(m[1]), b = parseFloat(m[2]);
      return a <= b ? [a, b] : [b, a];
    }
    var n = parseFloat(s);
    return isNaN(n) ? null : [n, n];
  }

  function parseRules(text) {
    var rules = [];
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var p = line.split('|');
      if (p.length < 3) return;
      var size = p[0].trim(), w = parseRange(p[1]), h = parseRange(p[2]);
      if (size && w && h) rules.push({ size: size, w: w, h: h });
    });
    return rules;
  }

  function gap(value, r) {
    var half = Math.max((r[1] - r[0]) / 2, 1);
    var center = (r[0] + r[1]) / 2;
    var out = value < r[0] ? r[0] - value : value > r[1] ? value - r[1] : 0;
    return { out: out / half, center: Math.abs(value - center) / half };
  }

  function recommend(rules, height, weight) {
    var best = null;
    rules.forEach(function (r) {
      var gw = gap(weight, r.w), gh = gap(height, r.h);
      var out = gw.out + gh.out * 0.6;
      var center = gw.center + gh.center * 0.6;
      if (!best || out < best.out - 1e-9 || (Math.abs(out - best.out) < 1e-9 && center < best.center)) {
        best = { size: r.size, out: out, center: center };
      }
    });
    if (best) best.exact = best.out === 0;
    return best;
  }

  /* Ürün bazlı öneri: önerilen beden üründe yoksa, üründeki en yakın bedene yönlendir + uyarı */
  function recommendForProduct(rules, sizes, height, weight) {
    var ideal = recommend(rules, height, weight);
    var out = { size: ideal.size, exact: ideal.exact, warn: '', ideal: ideal.size };
    if (!sizes.length) return out;
    var has = function (name) { return sizes.indexOf(String(name).trim().toLowerCase()) > -1; };
    if (has(ideal.size)) return out;
    var avail = rules.filter(function (r) { return has(r.size); });
    if (!avail.length) return out;
    var alt = recommend(avail, height, weight);
    var idx = function (name) {
      for (var i = 0; i < rules.length; i++) if (rules[i].size === name) return i;
      return -1;
    };
    out.size = alt.size;
    out.exact = true;
    out.warn = idx(alt.size) < idx(ideal.size) ? 'big' : 'small';
    return out;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function pickSize(modal, size) {
    var root = modal.__sgRoot;
    var scope = (root && root.closest && root.closest('product-info')) || document;
    var inputs = qsa(scope, 'variant-selects input[type="radio"]');
    var wanted = size.trim().toLowerCase();
    for (var i = 0; i < inputs.length; i++) {
      if ((inputs[i].value || '').trim().toLowerCase() === wanted) {
        inputs[i].click();
        return true;
      }
    }
    return false;
  }

  function handleAI(modal, form) {
    var result = qs(modal, '[data-sg-result]');
    var hInput = form.elements.height, wInput = form.elements.weight;
    var height = parseFloat(hInput.value), weight = parseFloat(wInput.value);
    var hOk = !isNaN(height) && height >= 100 && height <= 250;
    var wOk = !isNaN(weight) && weight >= 25 && weight <= 300;
    hInput.classList.toggle('is-error', !hOk);
    wInput.classList.toggle('is-error', !wOk);
    result.innerHTML = '';
    result.hidden = false;

    if (!hOk || !wOk) {
      result.appendChild(el('p', 'sg-ai__error', modal.dataset.tInvalid));
      return;
    }
    var rules = parseRules(modal.dataset.aiRules);
    if (!rules.length) {
      result.appendChild(el('p', 'sg-ai__error', modal.dataset.tNorules));
      return;
    }
    var sizes = String(modal.dataset.sizes || '').split('|').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    var rec = recommendForProduct(rules, sizes, height, weight);
    result.appendChild(el('p', 'sg-ai__label', rec.exact ? modal.dataset.tTitle : modal.dataset.tClosest));
    result.appendChild(el('p', 'sg-ai__size', rec.size));
    if (rec.warn) {
      var msg = (rec.warn === 'big' ? modal.dataset.tWarnBig : modal.dataset.tWarnSmall) || '';
      msg = msg.replace('__IDEAL__', rec.ideal).replace('__AVAIL__', rec.size);
      result.appendChild(el('p', 'sg-ai__warn', '\u26A0\uFE0F ' + msg));
    }
    if (modal.dataset.aiNote) result.appendChild(el('p', 'sg-ai__hint', modal.dataset.aiNote));

    var btn = el('button', 'sg-ai__pick', (modal.dataset.tSelect || '__SIZE__').replace('__SIZE__', rec.size));
    btn.type = 'button';
    btn.addEventListener('click', function () {
      if (pickSize(modal, rec.size)) close();
    });
    result.appendChild(btn);
  }

  /* ---------- Modal kurulum ---------- */
  function initModal(modal) {
    modal.addEventListener('click', function (e) {
      var t = e.target;
      if (t === modal) return close();
      var closeBtn = t.closest('[data-sg-close]');
      if (closeBtn) return close();
      var tab = t.closest('[data-sg-tab]');
      if (tab) return selectTab(modal, tab.getAttribute('data-sg-tab'));
      var unit = t.closest('[data-sg-unit]');
      if (unit) return setUnit(modal, unit.getAttribute('data-sg-unit'));
    });

    modal.addEventListener('keydown', function (e) {
      var tab = e.target.closest && e.target.closest('[data-sg-tab]');
      if (tab && (e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'Home' || e.key === 'End')) {
        var tabs = qsa(modal, '[data-sg-tab]');
        var i = tabs.indexOf(tab);
        if (e.key === 'ArrowRight') i = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') i = 0;
        else i = tabs.length - 1;
        e.preventDefault();
        return selectTab(modal, tabs[i].getAttribute('data-sg-tab'), true);
      }
      if (e.key === 'Tab') {
        var focusables = qsa(modal, 'button, a[href], input, [tabindex="0"]').filter(function (n) {
          return !n.disabled && n.offsetParent !== null;
        });
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === qs(modal, '.sg-dialog'))) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });

    var form = qs(modal, '[data-sg-ai-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        handleAI(modal, form);
      });
    }
  }

  /* ---------- Global olaylar ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-sg-open]');
    if (!trigger) return;
    var root = trigger.closest('[data-sg-root]');
    if (root) open(root, trigger);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && active) close();
  });

  /* Aynı üründe birden fazla blok eşleşirse sadece ilkini göster */
  function dedupe() {
    var seen = [];
    qsa(document, '[data-sg-root]').forEach(function (root) {
      var scope = root.closest('product-info') || document.body;
      if (seen.indexOf(scope) > -1) root.hidden = true;
      else seen.push(scope);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dedupe);
  else dedupe();
  document.addEventListener('shopify:section:load', dedupe);

  document.addEventListener('shopify:section:unload', function () { close(); });
})();
